/**
 * Legacy storage service - NO LONGER USED
 * The application now uses IDB through expense-repository.impl.ts
 * This file exists only to prevent import errors in unused Effect-based code
 */

import * as Effect from 'effect/Effect';
import * as Context from 'effect/Context';
import * as Layer from 'effect/Layer';

export class StorageError {
  readonly _tag = 'StorageError';
  constructor(
    readonly message: string,
    readonly cause?: unknown
  ) {}
}

export class NotFoundError {
  readonly _tag = 'NotFoundError';
  constructor(
    readonly entity: string,
    readonly id: string
  ) {}
}

// Stub service that always fails
export interface StorageService {
  get<T>(table: string, id: string): Effect.Effect<T, NotFoundError | StorageError>;
  getAll<T>(table: string): Effect.Effect<T[], StorageError>;
  create<T>(table: string, data: T): Effect.Effect<T, StorageError>;
  update<T>(table: string, id: string, data: Partial<T>): Effect.Effect<T, NotFoundError | StorageError>;
  delete(table: string, id: string): Effect.Effect<void, NotFoundError | StorageError>;
  bulkCreate<T>(table: string, data: T[]): Effect.Effect<void, StorageError>;
  bulkUpdate<T>(table: string, updates: Array<{ id: string; data: Partial<T> }>): Effect.Effect<void, StorageError>;
  query<T>(table: string, filter: (item: T) => boolean): Effect.Effect<T[], StorageError>;
  getDirty<T>(table: string): Effect.Effect<T[], StorageError>;
  markSynced(table: string, id: string): Effect.Effect<void, StorageError>;
  queueOperation(operation: any): Effect.Effect<void, StorageError>;
  getQueuedOperations(): Effect.Effect<any[], StorageError>;
  updateQueueStatus(id: number, status: string, error?: string): Effect.Effect<void, StorageError>;
  getMetadata(key: string): Effect.Effect<any, StorageError>;
  setMetadata(key: string, value: any): Effect.Effect<void, StorageError>;
  clearAll(): Effect.Effect<void, StorageError>;
}

export const StorageService = Context.GenericTag<StorageService>('StorageService');

// Stub implementation that returns errors
const stubImplementation: StorageService = {
  get: () => Effect.fail(new StorageError('Storage service disabled - use IDB repository')),
  getAll: () => Effect.fail(new StorageError('Storage service disabled - use IDB repository')),
  create: () => Effect.fail(new StorageError('Storage service disabled - use IDB repository')),
  update: () => Effect.fail(new StorageError('Storage service disabled - use IDB repository')),
  delete: () => Effect.fail(new StorageError('Storage service disabled - use IDB repository')),
  bulkCreate: () => Effect.fail(new StorageError('Storage service disabled - use IDB repository')),
  bulkUpdate: () => Effect.fail(new StorageError('Storage service disabled - use IDB repository')),
  query: () => Effect.fail(new StorageError('Storage service disabled - use IDB repository')),
  getDirty: () => Effect.fail(new StorageError('Storage service disabled - use IDB repository')),
  markSynced: () => Effect.fail(new StorageError('Storage service disabled - use IDB repository')),
  queueOperation: () => Effect.fail(new StorageError('Storage service disabled - use IDB repository')),
  getQueuedOperations: () => Effect.fail(new StorageError('Storage service disabled - use IDB repository')),
  updateQueueStatus: () => Effect.fail(new StorageError('Storage service disabled - use IDB repository')),
  getMetadata: () => Effect.fail(new StorageError('Storage service disabled - use IDB repository')),
  setMetadata: () => Effect.fail(new StorageError('Storage service disabled - use IDB repository')),
  clearAll: () => Effect.fail(new StorageError('Storage service disabled - use IDB repository')),
};

export const StorageLayer = Layer.succeed(StorageService, stubImplementation);